var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competition-statement ml-md-30" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _c("panel-competition-form-box", [
              _c("div", { staticClass: "row w100" }, [
                _c("div", { staticClass: "col-12 col-md-8" }, [
                  _c("h5", { staticClass: "mab16" }, [
                    _vm._v("Zgody uczestników"),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Formularz zgód możesz pobrać w zbiorczym pliku PDF, przygotowanym do wydruku. Indywidualne formularze zgód będą wysyłane do uczestników w mailu potwierdzającym rejestrację w zawodach. "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-4" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: {
                          btn2: "",
                          icon: "fas fa-download",
                          disabled: _vm.loadingPdf,
                          loading: _vm.loadingPdfBulk,
                        },
                        on: { click: _vm.downloadBulkPdf },
                      },
                      [_vm._v(" Pobierz zbiorczy plik ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "mat16" },
                      [
                        _c(
                          "base-button",
                          {
                            attrs: {
                              btn2: "",
                              icon: "fas fa-download",
                              disabled: _vm.loadingPdf,
                              loading: _vm.loadingPdfEmpty,
                            },
                            on: { click: _vm.downloadEmptyPdf },
                          },
                          [_vm._v(" Pobierz pustą kartę ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "row w100 mat16" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("p", { staticClass: "mab16" }, [
                    _vm._v("Kolejność uczestników w pliku PDF"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "radio-wrap-column" },
                    _vm._l(_vm.orderOptions, function (option) {
                      return _c("panel-input-base-radio", {
                        key: option.value,
                        attrs: { name: "statementOrder", option: option },
                        model: {
                          value: _vm.order,
                          callback: function ($$v) {
                            _vm.order = $$v
                          },
                          expression: "order",
                        },
                      })
                    }),
                    1
                  ),
                ]),
              ]),
            ]),
            _c("panel-competition-form-box", { staticClass: "mat16" }, [
              _c("div", { staticClass: "row w100" }, [
                _c("div", { staticClass: "col-12 col-md-8" }, [
                  _c("p", { staticClass: "mab16" }, [_vm._v("Format wydruku")]),
                  _c("div", { staticClass: "radios2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.perpage,
                          expression: "perpage",
                        },
                      ],
                      attrs: { id: "perpage_1", type: "radio" },
                      domProps: { value: 1, checked: _vm._q(_vm.perpage, 1) },
                      on: {
                        change: function ($event) {
                          _vm.perpage = 1
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "perpage_1" } }, [
                      _vm._v(" 1 formularz na stronie A4 "),
                      _c("span", { staticClass: "optional" }, [
                        _vm._v("(zawiera zamówienia ze sklepu)"),
                      ]),
                    ]),
                    _c("br"),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.perpage,
                          expression: "perpage",
                        },
                      ],
                      attrs: { id: "perpage_2", type: "radio" },
                      domProps: { value: 2, checked: _vm._q(_vm.perpage, 2) },
                      on: {
                        change: function ($event) {
                          _vm.perpage = 2
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "perpage_2" } }, [
                      _vm._v("2 formularze na stronie A4"),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "col-12 col-md-4" }, [
                  _c("div", { staticClass: "form-hint-wrap" }, [
                    _c("p", { staticClass: "form-hint" }, [
                      _vm._v(
                        " Formularz zawierający zamówienia ze sklepu zajmuje całą stronę A4. "
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(
                        " Formularze bez wykazu zakupionych produktów będą umieszczane po dwa na stronie A4. "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "lang-switcher mat16 mab16" },
              _vm._l(_vm.langs, function (lang) {
                return _c(
                  "button",
                  {
                    key: lang,
                    staticClass: "lang-switcher__btn",
                    class: {
                      "lang-switcher__btn--active": _vm.activeLang === lang,
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.activeLang = lang
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(lang.toUpperCase()) + " ")]
                )
              }),
              0
            ),
            _c("panel-competition-form-box", [
              _c("div", { staticClass: "row w100" }, [
                _c("div", { staticClass: "col-12 col-md-8" }, [
                  _c("div", { staticClass: "row mab24 statement-preview" }, [
                    _c("div", { staticClass: "col-3" }, [
                      _c("p", { staticClass: "txt--s1" }, [_vm._v("Adam")]),
                      _c("p", { staticClass: "txt--s2" }, [_vm._v("Kowalski")]),
                    ]),
                    _c("div", { staticClass: "col-3" }, [
                      _c("p", { staticClass: "txt--s1" }, [
                        _vm._v("Data urodzenia"),
                      ]),
                      _c("p", { staticClass: "txt--s2" }, [
                        _vm._v("10.10.1990"),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-3" }, [
                      _c("p", { staticClass: "txt--s1" }, [_vm._v("Miasto")]),
                      _c("p", { staticClass: "txt--s2" }, [_vm._v("Warszawa")]),
                    ]),
                    _c("div", { staticClass: "col-3" }, [
                      _c("p", { staticClass: "txt--s1" }, [
                        _vm._v("Płeć"),
                        _c("span", { staticClass: "pull-right" }, [
                          _vm._v("Nr"),
                        ]),
                      ]),
                      _c("p", { staticClass: "txt--s2" }, [
                        _vm._v("M"),
                        _c("span", { staticClass: "pull-right" }, [
                          _vm._v("123"),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("p", { staticClass: "mab16" }, [
                    _vm._v("Dodatkowe informacje"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.activeStatement.fields, function (field, index) {
                      return _c(
                        "div",
                        {
                          key: `${_vm.activeLang}-field-${index}`,
                          staticClass: "col-6 col-md-3 mab8",
                        },
                        [
                          _c("base-input-select", {
                            staticClass: "statement-field-select",
                            attrs: {
                              value: field,
                              options: _vm.fieldOptions,
                              "label-select": "label",
                              reduce: (o) => o.value,
                              "is-panel": "",
                              clearable: false,
                              searchable: false,
                              placeholder: "Brak",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setField(index, $event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", { staticClass: "col-12 col-md-4" }, [
                  _c("div", { staticClass: "form-hint-wrap" }, [
                    _c("p", { staticClass: "form-hint" }, [
                      _vm._v(
                        "Wybierz dodatkowe informacje widoczne na wydruku zgody."
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._l(_vm.activeStatement.contents, function (content, index) {
              return _c(
                "panel-competition-form-box",
                {
                  key: `${_vm.activeLang}-content-${index}`,
                  staticClass: "mat16",
                },
                [
                  _c("div", { staticClass: "row w100" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-8" },
                      [
                        _c("panel-input-area", {
                          attrs: {
                            value: content,
                            label: "Treść z miejscem na podpis",
                            rows: _vm.contentRows(content),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.setContent(index, $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-12 col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-hint-wrap" },
                        [
                          _c("p", { staticClass: "form-hint mat24" }, [
                            _vm._v(
                              " Pod treścią zgody znajduje się miejsce na podpis uczestnika. "
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v(
                              " Upewnij się, czy wpisana treść mieści się na wydruku. "
                            ),
                          ]),
                          _c(
                            "base-button",
                            {
                              staticClass: "mat16",
                              attrs: { btn2: "", icon: "fas fa-trash" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeContent(index)
                                },
                              },
                            },
                            [_vm._v(" Usuń ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            _c("div", { staticClass: "row mat16 mab24" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "add-new-content-wrap" },
                  [
                    _c(
                      "base-button",
                      { attrs: { btn2: "" }, on: { click: _vm.addContent } },
                      [_vm._v("Dodaj treść zgody")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "row mat16 mab64 align-items-center" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-5" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: {
                        btn2: "",
                        icon: "fas fa-trash",
                        disabled: _vm.loadingDefault,
                        loading: _vm.loadingDefault,
                      },
                      on: { click: _vm.restoreDefault },
                    },
                    [_vm._v(" Przywróć domyślną treść zgód ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-md-4 offset-md-3" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: {
                        btn1: "",
                        disabled: _vm.saving,
                        loading: _vm.saving,
                      },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Zapisz")]
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }